// extracted by mini-css-extract-plugin
module.exports = {"entrance-fee-summary":"entrance-fee-summary__8rYgm"};